import React, { useContext, useEffect, useRef, useState } from 'react';
import { requestCanceller } from '../../../service/axiosCancelToken';
import Comment from './Comment';
import './Comments.css';
import { changeStatusCommentById, deleteCommentById, getAllComments } from './../../../service/commentService';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import LoadingSpinner from '../../shared/LoadingSpinner';
import DashboardContext from '../../context/dashboardContext';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingBar from '../../shared/LoadingBar';
import DeleteModal from '../../shared/DeleteModal';

const Comments = () => {
    const [mode, setMode] = useState('queue');
    const [comments, setComments] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const dashContext = useContext(DashboardContext);

    const [searchInput, setSearchInput] = useState('');
    const [lastItemId, setLastItemId] = useState('');
    const [hasMore, setHasMore] = useState(true);

    const commentsRef = useRef(null);
    const commentCountRef = useRef(null);
    const [allDocumentsCounts, setAllDocumentsCounts] = useState();
    const [countsOfMode, setCountsOfMode] = useState({
        queue: 0,
        published: 0
    });

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const onSearchHandler = (event) => {
        commentsRef.current = null;
        let searched = event.target.value;
        setSearchInput(searched);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    const changeModeHandler = (newMode) => {
        if (newMode === mode)
            return;
        commentsRef.current = null;
        setMode(newMode);
        setLastItemId('');
        setHasMore(true);
        setIsLoading(true);
    };

    useEffect(() => {
        if (comments && commentCountRef && commentCountRef.current <= comments.length) {
            setHasMore(false);
        }
    }, [comments, commentCountRef]);

    const fetchMoreData = async () => {
        const lastItemId = comments[comments.length - 1]._id;
        setLastItemId(lastItemId);
    };

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllComments = async () => {
            try {
                let params = { id: lastItemId, searchText: searchInput, mode: mode }
                let { status, data } = await getAllComments(params, { cancelToken: cancelRequest.signal });
                if (status === 201) {
                    commentCountRef.current = data.counts;
                    setAllDocumentsCounts(data.allDocs);
                    setCountsOfMode(data.allModesCount);

                    if (commentsRef.current) {
                        commentsRef.current = commentsRef.current.concat(data.comments);
                        setComments(commentsRef.current);

                    }
                    else {
                        commentsRef.current = data.comments;
                        setComments(commentsRef.current);
                    }
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchAllComments();
        return () => {
            cancelRequest.cancel();
        }
    }, [searchInput, lastItemId, mode]);

    useEffect(() => {
        if (allDocumentsCounts && dashContext.commentsCount !== allDocumentsCounts) {
            dashContext.setCommentsCount(allDocumentsCounts);
        }
    }, [allDocumentsCounts, dashContext]);

    const history = useHistory();
    const { addToast } = useToasts();

    const changeStatusHandler = async (commentId) => {
        try {
            setIsLoading(true);
            const { status } = await changeStatusCommentById(commentId);
            if (status === 201) {
                addToast("کامنت مورد نظر منتشر شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                let allItems = [...comments];
                let filterItems = allItems.filter(item => item._id !== commentId);
                setComments([...filterItems]);
                setCountsOfMode(prev => {
                    return {
                        queue: prev.queue - 1,
                        published: prev.published + 1
                    }
                })
                setIsLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            else if (err.response && err.response.status === 404) {
                addToast("چنین نظری  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/comment')
            }
        }
    }
    const deleteHandler = async (commentId) => {
        try {
            setIsLoading(true);
            const { status } = await deleteCommentById(commentId);
            if (status === 201) {
                addToast("کامنت مورد نظر حذف شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                setAllDocumentsCounts(prev => --prev);
                let allItems = [...comments];
                let filtered = allItems.filter(item => item._id !== commentId);
                setComments(filtered);
                setCountsOfMode(prev => {
                    return {
                        ...prev,
                        queue: prev.queue - 1
                    }
                })
                setIsLoading(false);
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
            else if (err.response && err.response.status === 404) {
                addToast("چنین کامنتی  وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/comment')
            }
        }
    }

    useEffect(() => {
        if(deleteId)
        setShowDeleteDialog(true);
        else
        setShowDeleteDialog(false);
    },[deleteId]);

    return (
        <div className="all-comments">
            <header className="d-flex flex-column flex-sm-row justify-content-around justify-content-sm-between">
                <h1 className="all-comments-header text-center text-sm-left">نظرات</h1>
                <div className="d-flex mx-md-0 search-comments ">
                    <span className="text-muted">
                        <i className="fa fa-search"></i>
                    </span>
                    <input
                        type="text"
                        placeholder="جستجو"
                        className="col inline-block form-control mb-3 mb-sm-0"
                        onChange={onSearchHandler}
                        value={searchInput}
                    />
                </div>
                <DeleteModal
                    show={showDeleteDialog}
                    closeModal={() => setDeleteId()}
                    deleteId={deleteId}
                    deleteHandler={deleteHandler}
                    
                />
            </header>
            <ul className="nav nav-tabs" >
                <li className="nav-item"
                    onClick={() => changeModeHandler('queue')}
                >
                    <span className={mode === 'queue' ? "nav-link active" : "nav-link"}>
                        صف انتشار
                        <span className={`badge badge-secondary badge-pill ml-2 ${mode === 'queue' && 'badge-dark'}`}>
                            {countsOfMode.queue}
                        </span>
                    </span>
                </li>
                <li className="nav-item"
                    onClick={() => changeModeHandler('published')}
                >
                    <span className={mode === 'published' ? "nav-link active" : "nav-link"}>
                        منتشر شده
                        <span className={`badge badge-secondary badge-pill ml-2 ${mode === 'published' && 'badge-dark'}`}>
                            {countsOfMode.published}
                        </span>
                    </span>
                </li>
            </ul>
            <section className="all-comments-body">
                {
                    (isLoading || !comments) ?
                        <div style={{ height: '70vh' }} className="d-flex">
                            <div className="text-center align-self-center mx-auto">
                                <LoadingSpinner />
                            </div>
                        </div>
                        :
                        <InfiniteScroll
                            dataLength={comments && comments.length}
                            next={fetchMoreData}
                            hasMore={hasMore}
                            loader={
                                <div className="d-flex mt-2">
                                    <span className="mx-auto">
                                        <LoadingBar
                                            type="spinningBubbles"
                                            color="#0eac1b"
                                        />
                                    </span>
                                </div>
                            }
                            endMessage={
                                <p className="text-center mt-3">
                                    <b>The End</b>
                                </p>
                            }
                        >
                            {
                                comments.map((comment, index) =>
                                    <Comment
                                        key={comment._id}
                                        id={comment._id}
                                        number={index + 1}
                                        itemType={comment.itemType}
                                        person={comment.personId}
                                        place={comment.placeId}
                                        insertDate={comment.insertDate}
                                        mobileNumber={comment.mobileNumber}
                                        author={comment.author}
                                        comment={comment.comment}
                                        status={comment.status}
                                        changeStatus={changeStatusHandler}
                                        deleteComment={() => setDeleteId(comment._id)}
                                    />
                                )
                            }
                        </InfiniteScroll>
                }
            </section>
        </div>
    );
}

export default Comments;